import { useEffect, useRef, useState } from "react";
import { Row, Table, Container, Col, Form, Button, OverlayTrigger, Popover, InputGroup } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import sortBy from "lodash.sortby";
import SatAPI from "../../../_services/sat";
import toastService from "../../../_services/toastService";
import DocentList from "./components/DocentList";
import AssignmentEdit from "./components/AssignmentEdit";
import VTESimulationModal from "./components/VTESimulationModal";
import StageOLA from "./components/StageOLA";
import { loadParameters } from "../../../_helpers/calculations";
import { getCircularReplacer } from "../../../_helpers/json";
import { sortProgrammesLikeOpleidingenPage, isShownInOpleidingenFilter } from "../../../_helpers/sortProgrammes";

const api = SatAPI();
const OLA_ASSIGNMENT_DIFF_SNAPSHOT_STORAGE_KEY = "SAT-OlaAssignmentDiff-SnapshotName";
const OLA_ASSIGNMENT_DIFF_OPEN_STORAGE_KEY = "SAT-OlaAssignmentDiff-Open";

function OLAAssignment() {
  const snapshot = useSelector(state => state.snapshot.fileName);

  const [olas, setOLAsInt] = useState([]);
  const [opos, setOpos] = useState([]);
  const [programmes, setProgrammes] = useState([]);
  const [phases, setPhases] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingLight, setLoadingLight] = useState(false);

  const [modal, setModal] = useState(null);
  const [VTEModal, setVTEModal] = useState(null);
  const [parameters, setParameters] = useState({});
  const [diffSnapshotName, setDiffSnapshotName] = useState("");
  const [runningDiff, setRunningDiff] = useState(false);
  const [assignmentDiffData, setAssignmentDiffData] = useState(null);
  const [isDiffOpen, setIsDiffOpen] = useState(false);
  const [availableSnapshots, setAvailableSnapshots] = useState([]);
  const [highlightedOlaID, setHighlightedOlaID] = useState(null);
  const diffDetailsContainerRef = useRef(null);
  const olaRowRefs = useRef({});

  // calculated
  const [tags, setTags] = useState([]);
  const [phaseIDs, setPhaseIDs] = useState([]);

  // filters
  const [selectedProgrammeIDs, setSelectedProgrammeIDs] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [selectedPhaseIDs, setSelectedPhaseIDs] = useState([]);
  const [filterNotFull, setFilterNotFull] = useState(false);


  // custom hooks
  const setOLAs = (o, params) => {
    setOLAsInt(
      o.map(ola => {
        if (!parameters.general && !params) {
          return ola; // no parameters loaded do not edit it
        }
        if (!parameters.general && !params) {
          return ola; // no parameters loaded and not passed any do not edit it
        }
        if (parameters.general) {
          // if parameters are loaded use those
          params = parameters;
        }
        ola.assignments.map(assignment => {
          //assignment.collegaVTE = calculateRoundedCollegaVTEPreFetched(assignment.collega, ola.assignments, [], parallels, allAssignments, params.general, params.cs, params.ects, false);

          assignment.numberOfAssignments = ola.assignments.filter(a => a.collegaID === assignment.collegaID).length;
          console.log(assignment.numberOfAssignments);
          return assignment;
        });

        //ola.vte = calculateRoundedOLAVTEPreFetched(ola, ola.assignments, ola.phases, parallels, allAssignments, params.general, params.cs, params.ects);
        return ola;
      }),
    );
  };

  // recalc percentages when parameters change or just get loaded
  useEffect(() => {
    setOLAs(olas);
  }, [parameters]);

  /*
  const markAsChanged = id => {
    setHasChanges({ ...hasChanges, [id]: true });
  };
  */

  const runFilter = (newOLAs, setOLAParams) => {
    // filter OLAs
    setOLAs(
      (newOLAs || olas).map(ola => {
        ola.show = true; // default

        // filter by programme
        if (selectedProgrammeIDs.length > 0 && !selectedProgrammeIDs.includes(ola.opo.programmeID)) {
          ola.show = false;
          return ola;
        }

        // filter by tags
        if (selectedTags.length > 0) {
          ola.show = false;
          ola.opo.tags.forEach(tag => {
            if (selectedTags.includes(tag.name)) {
              ola.show = true;
            }
          });
        }

        // filter by phase
        if (selectedPhaseIDs.length > 0) {
          ola.show = false;
          ola.phases.forEach(phase => {
            if (selectedPhaseIDs.includes(phase.phaseID)) {
              ola.show = true;
            }
          });
        }

        // filter by not full
        if (filterNotFull) {
          let isFull;

          if (ola.internship) {
            const totalAssigned = ola.assignments.reduce((s, a) => s + (a.internshipStudents || 0), 0);
            const totalPlanned = ola.phases.reduce((s, p) => s + p.phase.numberOfStudents + p.surplus, 0);
            isFull = totalAssigned >= totalPlanned;
          } else {
            const isPhaseFullyBooked = olaPhase => {
              const numberOfClasses = olaPhase.numberOfClassesOverride || olaPhase.phase.numberOfClasses;
              const hasPhaseOverride = olaPhase.teachersPerClassOverride !== null && olaPhase.teachersPerClassOverride !== ola.teachersPerClass;
              const teachersPerClass = hasPhaseOverride ? olaPhase.teachersPerClassOverride : ola.teachersPerClass;
              const slots = numberOfClasses * teachersPerClass;
              const assignmentsInPhase = ola.assignments.filter(a => a.phaseID === olaPhase.phaseID).length;
              return assignmentsInPhase >= slots;
            };

            isFull = ola.planPerPhase
              ? ola.phases.every(isPhaseFullyBooked)
              : ola.assignments.length >= ola.classes * ola.teachersPerClass;
          }

          if (isFull) {
            ola.show = false;
          }
        }
        return ola;
      }, setOLAParams),
    );
  };

  useEffect(runFilter, [selectedProgrammeIDs, selectedTags, selectedPhaseIDs, filterNotFull]);

  const loadSnapshots = async () => {
    try {
      const snapshots = await api.getSnapshots();
      const snapshotNames = [...new Set(
        (snapshots || [])
          .map(s => (s.fileName || s.name || "").trim())
          .filter(Boolean),
      )].sort((a, b) => b.localeCompare(a));

      setAvailableSnapshots(snapshotNames);
      return snapshotNames;
    } catch {
      setAvailableSnapshots([]);
      return [];
    }
  };

  const snapshotExists = async snapshotName => {
    const snapshots = availableSnapshots.length > 0 ? availableSnapshots : await loadSnapshots();
    return snapshots.includes(snapshotName);
  };

  const setSelectedSnapshotName = snapshotName => {
    setDiffSnapshotName(snapshotName);
    localStorage.setItem(OLA_ASSIGNMENT_DIFF_SNAPSHOT_STORAGE_KEY, snapshotName);
  };

  const clearSelectedSnapshotName = () => {
    setDiffSnapshotName("");
    setAssignmentDiffData(null);
    setDiffOpenState(false);
    localStorage.removeItem(OLA_ASSIGNMENT_DIFF_SNAPSHOT_STORAGE_KEY);
  };

  const setDiffOpenState = isOpen => {
    setIsDiffOpen(isOpen);
    localStorage.setItem(OLA_ASSIGNMENT_DIFF_OPEN_STORAGE_KEY, isOpen ? "true" : "false");
  };

  const collapseAllDiffDetails = () => {
    const container = diffDetailsContainerRef.current;
    if (!container) {
      return;
    }

    container.querySelectorAll("details[open]").forEach(detail => detail.removeAttribute("open"));
  };

  const jumpToOlaRow = olaID => {
    const normalizedOlaID = `${olaID}`;
    const row = olaRowRefs.current[normalizedOlaID];

    if (!row) {
      toastService.send({ title: "Rij niet zichtbaar", message: "De overeenkomstige OLA-rij werd niet gevonden in de huidige tabelweergave." });
      return;
    }

    if (row.classList.contains("d-none")) {
      toastService.send({ title: "Rij gefilterd", message: "De rij is momenteel weggefilterd. Pas eerst de filters aan." });
      return;
    }

    row.scrollIntoView({ behavior: "smooth", block: "center" });
    setHighlightedOlaID(normalizedOlaID);
    setTimeout(() => setHighlightedOlaID(null), 1800);
  };

  const openEditModalFromDiff = item => {
    const olaIndex = olas.findIndex(ola => `${ola.ID ?? ola.id}` === `${item.olaId ?? item.olaID}`);

    if (olaIndex === -1) {
      toastService.send({ title: "OLA niet gevonden", message: "Deze OLA kon niet worden geopend voor bewerken." });
      return;
    }

    const assignmentID = item.ID ?? item.id;
    const ola = olas[olaIndex];
    const assignment = (ola.assignments || []).find(a => `${a.ID ?? a.id}` === `${assignmentID}`)
      || (ola.assignments || []).find(a => `${a.collegaID ?? a.collegaId}` === `${item.collegaId ?? item.collegaID}`);

    if (!assignment) {
      toastService.send({ title: "Toewijzing niet gevonden", message: "De bijhorende toewijzing is niet zichtbaar in de huidige tabelweergave." });
      return;
    }

    openEdit(olaIndex, assignment);
  };

  const mapAssignmentDiffFieldNameToLabel = fieldName => {
    const fieldLabels = {
      collegaId: "Docent",
      collegaID: "Docent",
      collegaName: "Docent",
      olaId: "OLA",
      olaID: "OLA",
      olaName: "OLA",
      percentageOverride: "Percentage aanpassing",
      opoResponsible: "OPO-coördinator",
      comment: "Commentaar",
    };

    return fieldLabels[fieldName] || fieldName;
  };

  const formatAssignmentDiffValue = value => {
    if (value === null || value === undefined || value === "") {
      return "(leeg)";
    }

    if (typeof value === "boolean") {
      return value ? "Ja" : "Nee";
    }

    if (typeof value === "object") {
      try {
        return JSON.stringify(value);
      } catch {
        return String(value);
      }
    }

    return `${value}`;
  };

  const formatAssignmentDiffFieldValue = (fieldName, value, item) => {
    if (fieldName === "collegaId" || fieldName === "collegaID") {
      return item?.collegaName || formatAssignmentDiffValue(value);
    }

    if (fieldName === "olaId" || fieldName === "olaID") {
      return item?.olaName || formatAssignmentDiffValue(value);
    }

    return formatAssignmentDiffValue(value);
  };

  const formatError = error => {
    if (error?.message) {
      return error.message;
    }

    if (typeof error === "string") {
      return error;
    }

    try {
      return JSON.stringify(error);
    } catch {
      return `${error}`;
    }
  };

  const getAssignmentContextMaps = opoList => {
    const contextByOlaId = new Map();
    const contextByOpoId = new Map();

    (opoList || []).forEach(opo => {
      const opoId = opo?.ID ?? opo?.id ?? null;
      const opoName = opo?.name || "";
      const opoZCode = opo?.zCode || "";

      if (opoId !== null && opoId !== undefined) {
        contextByOpoId.set(`${opoId}`, {
          opoId,
          opoName,
          opoZCode,
        });
      }

      (opo?.olas || []).forEach(ola => {
        const olaId = ola?.ID ?? ola?.id ?? null;
        if (olaId === null || olaId === undefined) {
          return;
        }

        contextByOlaId.set(`${olaId}`, {
          opoId,
          opoName,
          opoZCode,
          olaId,
          olaName: ola?.name || "",
          olaZCode: ola?.zCode || "",
        });
      });
    });

    return { contextByOlaId, contextByOpoId };
  };

  const flattenAssignmentsFromOpos = opoList => {
    const assignments = [];

    (opoList || []).forEach(opo => {
      (opo?.olas || []).forEach(ola => {
        (ola?.assignments || []).forEach(assignment => {
          assignments.push(assignment);
        });
      });
    });

    return assignments;
  };

  const normalizeAssignmentComparableValue = (fieldName, value) => {
    if (fieldName === "comment") {
      return `${value ?? ""}`.trim();
    }

    if (fieldName === "opoResponsible") {
      return Boolean(value);
    }

    if (fieldName === "percentageOverride") {
      const numeric = Number(value);
      return Number.isFinite(numeric) ? numeric : null;
    }

    if (fieldName === "collegaID" || fieldName === "olaID") {
      const numeric = Number(value);
      return Number.isFinite(numeric) ? numeric : null;
    }

    return value ?? null;
  };

  const buildAssignmentComparablePayload = assignment => ({
    collegaID: assignment?.collegaID ?? assignment?.collegaId ?? null,
    olaID: assignment?.olaID ?? assignment?.olaId ?? null,
    percentageOverride: assignment?.percentageOverride ?? null,
    opoResponsible: assignment?.opoResponsible ?? false,
    comment: assignment?.comment ?? "",
  });

  const enrichAssignmentForDiff = (assignment, contextMaps, section) => {
    const assignmentValues = buildAssignmentComparablePayload(assignment);
    const olaId = assignmentValues.olaID;
    const context = contextMaps.contextByOlaId.get(`${olaId ?? ""}`) || {};
    const collegaName = assignment?.collegaName
      || [assignment?.collega?.firstName, assignment?.collega?.lastName].filter(Boolean).join(" ").trim()
      || "";

    return {
      ...assignment,
      entityType: "Assignment",
      diffSection: section,
      opoId: context.opoId ?? null,
      opoName: context.opoName || "",
      opoZCode: context.opoZCode || "",
      olaId: context.olaId ?? olaId,
      olaName: context.olaName || "",
      olaZCode: context.olaZCode || "",
      collegaId: assignmentValues.collegaID,
      collegaName: collegaName,
      valueSource: assignmentValues,
    };
  };

  const compareAssignmentsLocally = (currentAssignments, snapshotAssignments, currentOpos, snapshotOpos) => {
    const currentContextMaps = getAssignmentContextMaps(currentOpos);
    const snapshotContextMaps = getAssignmentContextMaps(snapshotOpos);
    const currentById = new Map();
    const snapshotById = new Map();

    (currentAssignments || []).forEach(assignment => {
      const assignmentId = assignment?.ID ?? assignment?.id ?? null;
      if (assignmentId !== null && assignmentId !== undefined) {
        currentById.set(`${assignmentId}`, assignment);
      }
    });

    (snapshotAssignments || []).forEach(assignment => {
      const assignmentId = assignment?.ID ?? assignment?.id ?? null;
      if (assignmentId !== null && assignmentId !== undefined) {
        snapshotById.set(`${assignmentId}`, assignment);
      }
    });

    const created = [];
    const updated = [];
    const deleted = [];
    const comparedIds = new Set();

    currentById.forEach((currentAssignment, assignmentId) => {
      comparedIds.add(assignmentId);
      const snapshotAssignment = snapshotById.get(assignmentId);

      if (!snapshotAssignment) {
        created.push({
          ...enrichAssignmentForDiff(currentAssignment, currentContextMaps, "created"),
          newValues: buildAssignmentComparablePayload(currentAssignment),
        });
        return;
      }

      const currentValues = buildAssignmentComparablePayload(currentAssignment);
      const snapshotValues = buildAssignmentComparablePayload(snapshotAssignment);
      const fieldsChanged = [];
      const oldValues = {};
      const newValues = {};

      ["collegaID", "olaID", "percentageOverride", "opoResponsible", "comment"].forEach(fieldName => {
        const normalizedCurrent = normalizeAssignmentComparableValue(fieldName, currentValues[fieldName]);
        const normalizedSnapshot = normalizeAssignmentComparableValue(fieldName, snapshotValues[fieldName]);

        if (JSON.stringify(normalizedCurrent) !== JSON.stringify(normalizedSnapshot)) {
          fieldsChanged.push(fieldName);
          oldValues[fieldName] = snapshotValues[fieldName];
          newValues[fieldName] = currentValues[fieldName];
        }
      });

      if (fieldsChanged.length > 0) {
        updated.push({
          ...enrichAssignmentForDiff(currentAssignment, currentContextMaps, "updated"),
          fieldsChanged,
          oldValues,
          newValues,
        });
      }
    });

    snapshotById.forEach((snapshotAssignment, assignmentId) => {
      if (comparedIds.has(assignmentId)) {
        return;
      }

      deleted.push({
        ...enrichAssignmentForDiff(snapshotAssignment, snapshotContextMaps, "deleted"),
        oldValues: buildAssignmentComparablePayload(snapshotAssignment),
      });
    });

    return { created, updated, deleted };
  };

  const buildAssignmentDiffStructure = (diffData, currentOpos, snapshotOpos) => {
    const contextByOlaId = new Map();

    [...(snapshotOpos || []), ...(currentOpos || [])].forEach(opo => {
      const opoId = opo?.ID ?? opo?.id ?? null;
      const opoName = opo?.name || "";
      const opoZCode = opo?.zCode || "";

      (opo?.olas || []).forEach(ola => {
        const olaId = ola?.ID ?? ola?.id ?? null;
        contextByOlaId.set(`${olaId ?? "-"}`, {
          opoId,
          opoName,
          opoZCode,
          olaId,
          olaName: ola?.name || "",
          olaZCode: ola?.zCode || "",
        });
      });
    });

    const normalizeItem = (item, section) => {
      const olaId = item?.olaId ?? item?.olaID ?? null;
      const context = contextByOlaId.get(`${olaId ?? "-"}`) || {};
      const collegaName = item?.collegaName || [item?.collega?.firstName, item?.collega?.lastName].filter(Boolean).join(" ").trim();

      return {
        ...item,
        entityType: "Assignment",
        diffSection: section,
        opoId: context.opoId ?? null,
        opoName: context.opoName || item?.opoName || "",
        opoZCode: context.opoZCode || item?.opoZCode || "",
        olaId: context.olaId ?? olaId,
        olaName: item?.olaName || context.olaName || "",
        olaZCode: context.olaZCode || item?.olaZCode || "",
        collegaId: item?.collegaId ?? item?.collegaID ?? null,
        collegaName,
        valueSource: section === "created" ? (item?.newValues || item) : section === "deleted" ? (item?.oldValues || item) : item,
      };
    };

    const rootGroups = new Map();

    const ensureRootGroup = item => {
      const rootKey = `${item.opoId ?? item.opoName ?? item.opoZCode ?? "-"}`;
      let rootGroup = rootGroups.get(rootKey);

      if (!rootGroup) {
        rootGroup = {
          key: rootKey,
          opoId: item.opoId ?? null,
          opoName: item.opoName || item.opoZCode || "-",
          opoZCode: item.opoZCode || "",
          olaGroups: new Map(),
          summaryLabels: new Set(),
        };
        rootGroups.set(rootKey, rootGroup);
      }

      if (item.opoName && rootGroup.opoName === "-") {
        rootGroup.opoName = item.opoName;
      }

      return rootGroup;
    };

    const ensureOlaGroup = (rootGroup, item) => {
      const olaKey = `${item.olaId ?? item.olaName ?? "-"}`;
      let olaGroup = rootGroup.olaGroups.get(olaKey);

      if (!olaGroup) {
        olaGroup = {
          key: olaKey,
          olaId: item.olaId ?? null,
          olaName: item.olaName || item.olaZCode || "-",
          olaZCode: item.olaZCode || "",
          created: [],
          updated: [],
          deleted: [],
          summaryLabels: new Set(),
        };
        rootGroup.olaGroups.set(olaKey, olaGroup);
      }

      if (item.olaName && olaGroup.olaName === "-") {
        olaGroup.olaName = item.olaName;
      }

      return olaGroup;
    };

    const pushSectionItem = (section, item) => {
      const normalized = normalizeItem(item, section);
      const rootGroup = ensureRootGroup(normalized);
      const olaGroup = ensureOlaGroup(rootGroup, normalized);
      olaGroup[section].push(normalized);

      // add changed field labels to summaries
      (normalized.fieldsChanged || []).forEach(fieldName => {
        const label = mapAssignmentDiffFieldNameToLabel(fieldName);
        rootGroup.summaryLabels.add(label);
        olaGroup.summaryLabels.add(label);
      });

      // add a section label so the collapsed summary shows the type of change (e.g. Nieuwe toewijzing / Toewijzing aangepast / Verwijderde toewijzing)
      const sectionLabel = section === "created"
        ? "Nieuwe toewijzing"
        : section === "updated"
          ? "Toewijzing aangepast"
          : "Verwijderde toewijzing";

      rootGroup.summaryLabels.add(sectionLabel);
      olaGroup.summaryLabels.add(sectionLabel);
    };

    (diffData?.created || []).forEach(item => pushSectionItem("created", item));
    (diffData?.updated || []).forEach(item => pushSectionItem("updated", item));
    (diffData?.deleted || []).forEach(item => pushSectionItem("deleted", item));

    const roots = [...rootGroups.values()].sort((a, b) => `${a.opoName} ${a.opoZCode}`.localeCompare(`${b.opoName} ${b.opoZCode}`));

    roots.forEach(rootGroup => {
      rootGroup.olaGroups = [...rootGroup.olaGroups.values()].sort((a, b) => `${a.olaName} ${a.olaZCode}`.localeCompare(`${b.olaName} ${b.olaZCode}`));
      const summaryParts = [...rootGroup.summaryLabels];
      rootGroup.summaryText = summaryParts.length > 0 ? summaryParts.join(", ") : "Aangepast";
    });

    return {
      rootGroups: roots,
      partialComparison: false,
      summary: {
        created: (diffData?.created || []).length,
        updated: (diffData?.updated || []).length,
        deleted: (diffData?.deleted || []).length,
        total: (diffData?.created || []).length + (diffData?.updated || []).length + (diffData?.deleted || []).length,
      },
    };
  };

  const runAssignmentDiffWithSnapshot = async (selectedSnapshot, showErrorToast = true, showLoadingIndicator = true) => {
    if (showLoadingIndicator) {
      setRunningDiff(true);
    }

    try {
      // Call backend global assignments diff endpoint and fetch snapshot OPOs for context
      const [snapshotOposResult, assignmentsDiffResult] = await Promise.allSettled([
        api.getOPOs(selectedSnapshot),
        api.getAssignmentsDiff(selectedSnapshot),
      ]);

      if (snapshotOposResult.status !== "fulfilled") {
        throw snapshotOposResult.reason;
      }

      // If backend global diff call failed with 405 (method not allowed), fallback to local comparison
      if (assignmentsDiffResult.status !== "fulfilled") {
        const reason = assignmentsDiffResult.reason;
        if (reason && reason.status === 405) {
          // fetch snapshot assignments and compare locally as a fallback
          const snapshotAssignments = await api.getAssignments(selectedSnapshot);
          const currentAssignments = flattenAssignmentsFromOpos(opos);
          const mergedDiff = compareAssignmentsLocally(currentAssignments, snapshotAssignments, opos, snapshotOposResult.value || []);
          const result = buildAssignmentDiffStructure(mergedDiff, opos, snapshotOposResult.value || []);
          setAssignmentDiffData(result);
          localStorage.setItem(OLA_ASSIGNMENT_DIFF_SNAPSHOT_STORAGE_KEY, selectedSnapshot);
          return true;
        }

        // otherwise rethrow to be handled below
        throw assignmentsDiffResult.reason;
      }

      const snapshotOpos = snapshotOposResult.value || [];
      const diffFromBackend = assignmentsDiffResult.value || { created: [], updated: [], deleted: [] };

      const result = buildAssignmentDiffStructure(diffFromBackend, opos, snapshotOpos);
      setAssignmentDiffData(result);
      localStorage.setItem(OLA_ASSIGNMENT_DIFF_SNAPSHOT_STORAGE_KEY, selectedSnapshot);
      return true;
    } catch (error) {
      let message = formatError(error);
      try {
        // If the thrown error is a fetch Response, try to read its body for a useful message
        if (error && typeof error.text === "function") {
          const body = await error.text();
          try {
            const parsed = JSON.parse(body);
            message = parsed?.message || parsed?.error || JSON.stringify(parsed) || body || message;
          } catch (e) {
            message = body || message;
          }
        }
      } catch (e) {
        // ignore parsing errors
      }

      if (showErrorToast) {
        setAssignmentDiffData(null);
        toastService.send({ title: "Vergelijking mislukt", message });
      }
      return false;
    } finally {
      if (showLoadingIndicator) {
        setRunningDiff(false);
      }
    }
  };

  const runAssignmentDiff = async () => {
    const selectedSnapshot = diffSnapshotName.trim();

    if (!selectedSnapshot) {
      toastService.send({ title: "Snapshot vereist", message: "Vul een snapshotnaam in." });
      return;
    }

    try {
      const exists = await snapshotExists(selectedSnapshot);
      if (!exists) {
        setAssignmentDiffData(null);
        setDiffOpenState(false);
        toastService.send({ title: "Snapshot bestaat niet", message: "De ingevulde snapshot bestaat niet." });
        return;
      }
    } catch (error) {
      toastService.send({ title: "Snapshotcontrole mislukt", message: formatError(error) });
      return;
    }

    const succeeded = await runAssignmentDiffWithSnapshot(selectedSnapshot, true, true);
    if (succeeded) {
      setDiffOpenState(true);
    }
  };

  const refreshAssignmentsDiffAfterDataChange = async () => {
    const selectedSnapshot = diffSnapshotName.trim();
    if (!selectedSnapshot || !assignmentDiffData) {
      return;
    }

    await runAssignmentDiffWithSnapshot(selectedSnapshot, false, false);
  };

  const renderAssignmentDiffItem = item => {
    const changedFields = [...new Set(item.fieldsChanged || [])]
      .sort((a, b) => mapAssignmentDiffFieldNameToLabel(a).localeCompare(mapAssignmentDiffFieldNameToLabel(b)));

    return (
      <li key={`${item.diffSection}-${item.ID ?? item.id ?? item.olaId ?? item.collegaId ?? item.collegaName ?? "item"}`} className="border rounded bg-white px-2 py-1 mb-2">
        <div className="fw-semibold">
          {item.collegaName || `Docent #${item.collegaId ?? item.collegaID ?? "?"}`}
        </div>
        <div className="d-flex gap-3 mb-1">
        <Button variant="link" size="sm" className="p-0 text-decoration-none" onClick={() => jumpToOlaRow(item.olaId ?? item.olaID)}>
          Ga naar rij
        </Button>
        {item.diffSection !== "deleted" && (
          <Button variant="link" size="sm" className="p-0 text-decoration-none" onClick={() => openEditModalFromDiff(item)}>
            Bewerken
          </Button>
        )}
      </div>

        {item.diffSection === "updated" && changedFields.length > 0 ? (
          <ul className="list-unstyled mb-0">
            {changedFields.map((fieldName, index) => (
              <li key={`${item.diffSection}-${item.ID ?? item.id ?? item.olaId}-${fieldName}`} className={`py-1${index > 0 ? " border-top" : ""}`}>
                <div style={{ color: "#d32f2f", fontWeight: 500 }}>
                  {mapAssignmentDiffFieldNameToLabel(fieldName)}
                </div>
                <div className="small mt-1">
                  <div>
                    <span className="text-muted">Van:</span> <span style={{ color: "#b00020" }}>
                      {formatAssignmentDiffFieldValue(fieldName, item.oldValues?.[fieldName], item)}
                    </span>
                  </div>
                  <div>
                    <span className="text-muted">Naar:</span> <span style={{ color: "#1b5e20", fontWeight: 600 }}>
                      {formatAssignmentDiffFieldValue(fieldName, item.newValues?.[fieldName], item)}
                    </span>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        ) : null}

        {item.diffSection === "created" ? (
          <div className="small mt-2">
            <div><strong>Percentage:</strong> {formatAssignmentDiffFieldValue("percentageOverride", item.newValues?.percentageOverride ?? item.valueSource?.percentageOverride, item)}</div>
            <div><strong>OPO-coördinator:</strong> {formatAssignmentDiffFieldValue("opoResponsible", item.newValues?.opoResponsible ?? item.valueSource?.opoResponsible, item)}</div>
            <div><strong>Commentaar:</strong> {formatAssignmentDiffFieldValue("comment", item.newValues?.comment ?? item.valueSource?.comment, item)}</div>
          </div>
        ) : null}

        {item.diffSection === "deleted" ? (
          <div className="small mt-2">
            <div><strong>Percentage:</strong> {formatAssignmentDiffFieldValue("percentageOverride", item.oldValues?.percentageOverride ?? item.valueSource?.percentageOverride, item)}</div>
            <div><strong>OPO-coördinator:</strong> {formatAssignmentDiffFieldValue("opoResponsible", item.oldValues?.opoResponsible ?? item.valueSource?.opoResponsible, item)}</div>
            <div><strong>Commentaar:</strong> {formatAssignmentDiffFieldValue("comment", item.oldValues?.comment ?? item.valueSource?.comment, item)}</div>
          </div>
        ) : null}
      </li>
    );
  };

  const load = async (setLoad = true) => {
    try {
      setLoading(setLoad);
      const response = await api.getProgrammes(snapshot);
      response.sort((a, b) => a.name.localeCompare(b.name));
      setProgrammes(response);

      const phasesResponse = await api.getPhases(null, snapshot);
      console.warn(phasesResponse);

      phasesResponse.sort((a, b) => a.name.localeCompare(b.name));
      setPhases(phasesResponse);

      const oposResponse = await api.getOPOs(snapshot);
      oposResponse.sort((a, b) => b.name < a.name ? 1 : -1);
      /*
      let currentParallels = [];
      if (!snapshot) { // TEMPORARY WORKAROUND - old back-end always returns current parallels instead of parallels from snapshot
        currentParallels = await api.getParallels(snapshot);
        currentParallels.sort((a, b) => (b.mainOLA.name.localeCompare(a.mainOLA.name) || a.level - b.level) ? 1 : -1);
      }*/
      /*
            const allOLAsFromOPOS = [];
            oposResponse.forEach(opo => {
              opo.olas.forEach(ola => {
                allOLAsFromOPOS.push(ola);
              });
            });
      */


      // TODO: improve this in new back-end!
      // Overwrite the OLA's in parallel because they don't contain OLA phases,
      // which is necessary for calculation of student numbers
      /*
            currentParallels.forEach(parallel => {
              parallel.mainOLA = allOLAsFromOPOS.find((ola) => ola.ID === parallel.mainOLAID);
              parallel.subOLA = allOLAsFromOPOS.find((ola) => ola.ID === parallel.subOLAID);
            });
      
            setParallels(currentParallels);
      */
      const { general, cs, ects } = await loadParameters();
      setParameters({ general, cs, ects });

      const assignments = await api.getAssignments(snapshot);
      /*
            setAllAssignments(assignments); // for calculating parallels
      */
      const opoResponse = await api.getOPOs(snapshot);
      opoResponse.sort((a, b) => a.programme.name.localeCompare(b.programme.name) || a.name.localeCompare(b.name));
      setOpos(opoResponse);
      const allOLAs = [];
      opoResponse.forEach(opo => {
        opo.olas.forEach(ola => {
          ola.opo = opo;
          ola.classes = 0;
          ola.assignments = assignments.filter(a => a.olaID === ola.ID);
          ola.assignments.sort((a, b) => a.collega.lastName > b.collega.lastName);

          const opoRespAssignment = ola.assignments.filter(a => a.opoResponsible);
          if (opoRespAssignment.length > 0) {
            ola.assignments = sortBy(ola.assignments, [
              o => !o.opoResponsible,
              o => o.collegaID !== opoRespAssignment[0].collegaID,
              "collega.lastName",
              "collega.firstName",
            ]);
          } else {
            ola.assignments = sortBy(ola.assignments, ["collega.lastName", "collega.firstName"]);
          }

          ola.phases.forEach(phase => {
            ola.classes += (phase.numberOfClassesOverride || phase.phase.numberOfClasses) * (phase.teachersPerClassOverride != ola.teachersPerClass && ola.planPerPhase ? phase.teachersPerClassOverride : ola.teachersPerClass);
          });

          ola.show = true;
        });
        allOLAs.push(...opo.olas);
      });
      runFilter(allOLAs, { general, cs, ects });

      // check if SAT-PersonalProgrammeFilter exists in local storage - if not: create it to avoid null reference
      if (!localStorage.getItem("SAT-PersonalProgrammeFilter")) {
        localStorage.setItem("SAT-PersonalProgrammeFilter", JSON.stringify([]));
      }

      let personalProgrammeIDs = [];
      JSON.parse(localStorage.getItem("SAT-PersonalProgrammeFilter")).forEach(selectedProgramme => {
        personalProgrammeIDs = [...personalProgrammeIDs, selectedProgramme.ID];
      });
      setSelectedProgrammeIDs(personalProgrammeIDs);

      setLoading(false);
    } catch (error) {
      toastService.send({ title: "An error occured", message: error.toString() });
    }
  };

  const loadLight = async (setLoad = true) => {
    setLoadingLight(setLoad);
    const assignments = await api.getAssignments(snapshot);

    const allOLAs = [];
    opos.forEach(opo => {
      opo.olas.forEach(ola => {
        ola.opo = opo;
        ola.classes = 0;
        ola.assignments = assignments.filter(a => a.olaID === ola.ID);
        ola.assignments.sort((a, b) => a.collega.lastName > b.collega.lastName);

        const opoRespAssignment = ola.assignments.filter(a => a.opoResponsible);
        if (opoRespAssignment.length > 0) {
          ola.assignments = sortBy(ola.assignments, [
            o => !o.opoResponsible,
            o => o.collegaID !== opoRespAssignment[0].collegaID,
            "collega.lastName",
            "collega.firstName",
          ]);
        } else {
          ola.assignments = sortBy(ola.assignments, ["collega.lastName", "collega.firstName"]);
        }

        ola.phases.forEach(phase => {
          ola.classes += (phase.numberOfClassesOverride || phase.phase.numberOfClasses) * (phase.teachersPerClassOverride != ola.teachersPerClass && ola.planPerPhase ? phase.teachersPerClassOverride : ola.teachersPerClass);
        });

        ola.show = true;
      });
      allOLAs.push(...opo.olas);
    });
    setOpos([...opos]);
    runFilter(allOLAs);
    setLoadingLight(false);
  };

  useEffect(() => {
    load();
  }, [snapshot]);

  useEffect(() => {
    const savedSnapshotName = localStorage.getItem(OLA_ASSIGNMENT_DIFF_SNAPSHOT_STORAGE_KEY) || "";
    const savedOpenState = localStorage.getItem(OLA_ASSIGNMENT_DIFF_OPEN_STORAGE_KEY);
    const shouldOpenDiff = savedOpenState === "true";

    setDiffSnapshotName(savedSnapshotName);
    setIsDiffOpen(shouldOpenDiff);

    const initializePage = async () => {
      setLoading(true);

            await Promise.all([
        load(false),
        loadSnapshots(),
      ]);

      if (savedSnapshotName.trim()) {
        try {
          if (await snapshotExists(savedSnapshotName.trim())) {
            await runAssignmentDiffWithSnapshot(savedSnapshotName.trim(), false, false);
          } else {
            localStorage.removeItem(OLA_ASSIGNMENT_DIFF_SNAPSHOT_STORAGE_KEY);
            localStorage.setItem(OLA_ASSIGNMENT_DIFF_OPEN_STORAGE_KEY, "false");
            setDiffSnapshotName("");
            setIsDiffOpen(false);
          }
        } catch {
          // Keep the page usable even if diff restoration fails.
        }
      }

      setLoading(false);
    };

    initializePage();
  }, []);

  const toggleSelectedProgrammeFiler = (id, checked) => {
    if (checked) {
      setSelectedProgrammeIDs([...selectedProgrammeIDs, id]);
    } else {
      setSelectedProgrammeIDs(selectedProgrammeIDs.filter(i => i !== id));
    }
  };

  const toggleSelectedTag = (tag, checked) => {
    if (checked) {
      setSelectedTags([...selectedTags, tag]);
    } else {
      setSelectedTags(selectedTags.filter(t => t !== tag));
    }
  };

  const toggleSelectedPhaseID = (id, checked) => {
    if (checked) {
      setSelectedPhaseIDs([...selectedPhaseIDs, id]);
    } else {
      setSelectedPhaseIDs(selectedPhaseIDs.filter(i => i !== id));
    }
  };

  const updateAssignment = (data) => {
    api.updateAssignment(data.ID, JSON.parse(JSON.stringify(data, getCircularReplacer())))
      .then(async () => {
        await loadLight();
        await refreshAssignmentsDiffAfterDataChange();
      });
  };

  const removeAssignment = (assignment) => {
    /* if (!olas || !olas[olaIndex] || !olas[olaIndex].assignments) {
      return; // invalid OLA data
    } */

    api.deleteAssignment(assignment.ID).then(async () => {
      await loadLight();
      await refreshAssignmentsDiffAfterDataChange();
    });

    /*
    let newOLAs = [...olas];

    if (phase?.ID) {
      const filteredAssignments = newOLAs[olaIndex].assignments.filter(
        (assignment) => assignment.phaseID === phase.ID
      );

      if (classIndex >= filteredAssignments.length) {
        return; // invalid index (out of range)
      }

      const assignmentToRemove = filteredAssignments[classIndex];
      if (!assignmentToRemove) {
        return; // no assignment found
      }

      if (assignmentToRemove.ID) {
        setDeletedAssignments((prev) => [...prev, assignmentToRemove]);
      }

      newOLAs[olaIndex].assignments = newOLAs[olaIndex].assignments.filter(
        (assignment) => assignment.phaseID !== phase.ID || assignment !== assignmentToRemove
      );
    } else {
      if (classIndex >= newOLAs[olaIndex].assignments.length) {
        return; // invalid index (out of range)
      }

      const assignmentToRemove = newOLAs[olaIndex].assignments[classIndex];

      if (assignmentToRemove?.ID) {
        setDeletedAssignments((prev) => [...prev, assignmentToRemove]);
      }

      newOLAs[olaIndex].assignments.splice(classIndex, 1);
    }

    setOLAs(newOLAs);
    markAsChanged(newOLAs[olaIndex]?.ID);
    */
  };

  const openEdit = (olaIndex, data) => {
    setModal(
      <AssignmentEdit
        hideModal={() => {
          setModal(null);
        }}
        data={data}
        ola={olas[olaIndex]}
        saveData={d => updateAssignment(d)}
        removeAssignment={() => removeAssignment(data)}
      />,
    );
  };

  const openVTESimulationModal = ola => {
    setVTEModal(
      <VTESimulationModal
        hideModal={() => {
          setVTEModal(null);
        }}
        data={ola}
      />,
    );
  };

  /*
    const save = async () => {
      setSaving(true);
      const unblock = history.block("SAT is nog aan het opslaan, ben je zeker dat je deze pagina wilt verlaten?");
      try {
        await Promise.all(
          olas
            .filter(ola => hasChanges[ola.ID])
            .map(ola =>
              ola.assignments.map(async assignment => {
                assignment.olaID = ola.ID;
                if (assignment.ID) {
                  await api.updateAssignment(assignment.ID, JSON.parse(JSON.stringify(assignment, getCircularReplacer())));
                } else {
                  await api.createAssignment(JSON.parse(JSON.stringify(assignment, getCircularReplacer())));
                }
              }),
            ),
        );
  
        await Promise.all(
          deletedAssignments.map(async assignment => {
            await api.deleteAssignment(assignment.ID);
          }),
        );
        setDeletedAssignments([]);
        setHasChanges({});
        await load(false);
  
        //api.createSnapshot();
        toastService.send({ title: "Saved", message: "Saved successfully" });
        unblock();
      } catch (error) {
        toastService.send({ title: "An error occured", message: error.toString() });
      }
  
      setSaving(false);
    };
  */
  useEffect(() => {
    // no OLAs left? keep filters the same
    if (olas.filter(ola => ola.show).length === 0) {
      return;
    }
    // calculate tags
    const opotags = {};
    olas.forEach(ola => {
      if (!ola.show) return;
      ola.opo.tags.forEach(tag => {
        if (!opotags[tag.name]) {
          opotags[tag.name] = true;
        }
      });
    });
    setTags(Object.keys(opotags));

    // calculate phases
    const opophases = {};
    olas.forEach(ola => {
      ola.phases.forEach(phase => {
        if (!opophases[phase.phaseID] && (selectedProgrammeIDs.includes(phase.phase.programmeID) || selectedProgrammeIDs.length === 0)) {
          opophases[phase.phaseID] = true;
        }
      });
    });
    setPhaseIDs(Object.keys(opophases));
  }, [olas]);

  if (loading) {
    return (
      <div className="text-center">
        <i className="fad fa-spinner-third fa-spin fa-5x" />
      </div>
    );
  }

  const popover = (o, phaseID, phaseColor) => (
    <Popover className="docent-list">
      <Popover.Header as="h3">Docent toekennen</Popover.Header>
      <Popover.Body>
        <DocentList
          programme={o.opo.programme}
          olaId={o.ID}
          phaseId={phaseID}
          phaseColor={phaseColor}
          selectDocent={d => {
            const currentOla = olas.find(x => x.ID == o.ID);
            api.createAssignment(
              JSON.parse(JSON.stringify({
                collega: d,
                collegaID: d.ID,
                internshipStudents: 0,
                percentageOverride: 0,
                ola: currentOla,
                olaID: o.ID,
                opoResponsible: currentOla.assignments.length === 0 && !currentOla.internship,
                comment: "",
                phaseID: phaseID,
              }, getCircularReplacer()))
            ).then(x => {
              const updatedOLAs = olas.map(ola => {
                if (ola.ID === o.ID) {
                  ola.assignments.push(x);
                }
                return ola;
              });
              runFilter(updatedOLAs);
              refreshAssignmentsDiffAfterDataChange();
            });

            // markAsChanged(o.ID);
          }}
          ola={o.internship && o}
        />
      </Popover.Body>
    </Popover>
  );

  const legendPopover = (
    <Popover>
      <Popover.Header as="h3">Legende</Popover.Header>
      <Popover.Body>
        <p>
          <span className="text-info">
            <i className="far fa-comment-dots" />
          </span>{" "}
          Opmerking aanwezig
        </p>
        <p>
          <span className="text-warning">
            <i className="fas fa-bolt" />
          </span>{" "}
          Percentage override
        </p>
        <p>
          <i className="far fa-award" /> OPO-verantwoordelijke
        </p>
      </Popover.Body>
    </Popover>
  );

  return (
    <Container>
      {loadingLight &&
        <div className="loading-light">
          <div className="spin-center">
            <i className="fad fa-spinner-third fa-spin fa-5x" />
            <p>Data aan het opslaan</p>
          </div>
        </div>
      }
      {modal}
      {VTEModal}
      <Row className="align-items-start mb-3">
        <Col>
          <h1>Vakken</h1>
        </Col>
        <Col md={6} className="text-end">
          <div className="d-flex align-items-start gap-2">
            <InputGroup style={{ maxWidth: "380px", marginInlineEnd: "1rem" }}>
              <Form.Control
                type="text"
                list={diffSnapshotName ? "assignment-diff-snapshot-options" : undefined}
                value={diffSnapshotName}
                onChange={e => setSelectedSnapshotName(e.target.value)}
                placeholder="Zoek snapshot"
                autoComplete="off"
              />
              <datalist id="assignment-diff-snapshot-options">
                {availableSnapshots.map(snapshotName => (
                  <option key={snapshotName} value={snapshotName} />
                ))}
              </datalist>
              <Form.Select
                aria-label="Selecteer snapshot"
                value={diffSnapshotName}
                onChange={async e => {
                  const selectedValue = e.target.value;
                  setSelectedSnapshotName(selectedValue);
                  if (selectedValue) {
                    const succeeded = await runAssignmentDiffWithSnapshot(selectedValue, true, true);
                    if (succeeded) {
                      setDiffOpenState(true);
                    }
                  }
                }}
                className="flex-grow-0"
                style={{ width: "44px", paddingInline: "0.4rem", backgroundPosition: "center", textIndent: "-9999px", overflow: "hidden" }}
              >
                {availableSnapshots.map(snapshotName => (
                  <option key={snapshotName} value={snapshotName}>{snapshotName}</option>
                ))}
              </Form.Select>
            </InputGroup>
            <Button variant="primary" onClick={runAssignmentDiff} disabled={runningDiff} style={{ whiteSpace: "nowrap" }}>
              {runningDiff ? (
                <>
                  <i className="fad fa-spinner-third fa-spin" />
                  &nbsp;Vergelijken...
                </>
              ) : (
                <>
                  <i className="far fa-code-compare" />
                  &nbsp;Vergelijk toewijzingen
                </>
              )}
            </Button>
            {diffSnapshotName && (
              <Button variant="outline-secondary" onClick={clearSelectedSnapshotName}>
                Wissen
              </Button>
            )}
            <OverlayTrigger trigger="click" placement="left" overlay={legendPopover} rootClose>
              <Button variant="info">
                <i className="fas fa-question" />
              </Button>
            </OverlayTrigger>
          </div>
        </Col>
      </Row>

      {assignmentDiffData && isDiffOpen && (
        <Row className="mb-3">
          <Col>
            <div className="border rounded p-3 bg-light">
              <div className="d-flex justify-content-between align-items-start mb-3">
                <h5 className="mb-0">Toewijzingsveranderingen</h5>
                <div className="d-flex align-items-center gap-3">
                  <Button variant="link" className="p-0 text-decoration-none" onClick={collapseAllDiffDetails}>
                    Alles inklappen
                  </Button>
                  <Button variant="link" className="p-0 text-decoration-none" onClick={() => setDiffOpenState(false)}>
                    Sluiten
                  </Button>
                </div>
              </div>

              {assignmentDiffData.partialComparison && (
                <p className="mb-2 text-warning">
                  <strong>Opgelet:</strong> vergelijking lijkt onvolledig. Sommige contextgegevens ontbreken.
                </p>
              )}

              <p className="mb-2">
                <strong>Aangepast:</strong> {assignmentDiffData.summary.total ?? 0}
              </p>

              <div ref={diffDetailsContainerRef}>
                {assignmentDiffData.rootGroups.length > 0 ? (
                  <ul className="mb-0 list-unstyled">
                    {assignmentDiffData.rootGroups.map(rootGroup => (
                      <li key={rootGroup.key} className="mb-2">
                        <details className="border rounded bg-white px-2 py-1">
                          <summary className="fw-semibold">
                            {rootGroup.opoZCode ? `${rootGroup.opoZCode} - ` : ""}{rootGroup.opoName}
                            <span className="text-muted fw-normal">: {rootGroup.summaryText || "Aangepast"}</span>
                          </summary>
                          <div className="mt-2 small">
                        {rootGroup.olaGroups.length > 0 ? (
                        rootGroup.olaGroups.length === 1 ? (
                          <div className="mt-2">
                            {rootGroup.olaGroups[0].created.length > 0 && (
                              <div className="mb-3">
                                <strong>Nieuwe toewijzingen</strong>
                                <ul className="list-unstyled mb-0 mt-2">
                                  {rootGroup.olaGroups[0].created.map(renderAssignmentDiffItem)}
                                </ul>
                              </div>
                            )}
                            {rootGroup.olaGroups[0].updated.length > 0 && (
                              <div className="mb-3">
                                <strong>Gewijzigde toewijzingen</strong>
                                <ul className="list-unstyled mb-0 mt-2">
                                  {rootGroup.olaGroups[0].updated.map(renderAssignmentDiffItem)}
                                </ul>
                              </div>
                            )}
                            {rootGroup.olaGroups[0].deleted.length > 0 && (
                              <div>
                                <strong>Verwijderde toewijzingen</strong>
                                <ul className="list-unstyled mb-0 mt-2">
                                  {rootGroup.olaGroups[0].deleted.map(renderAssignmentDiffItem)}
                                </ul>
                              </div>
                            )}
                          </div>
                        ) : (
                          <ul className="list-unstyled mb-0 mt-2">
                            {rootGroup.olaGroups.map(olaGroup => {
                              const olaSummaryText = [...olaGroup.summaryLabels].join(", ") || "Aangepast";

                              return (
                                <li key={olaGroup.key} className="border rounded bg-white px-2 py-1 mb-2">
                                  <details>
                                    <summary className="fw-semibold">
                                      {olaGroup.olaZCode ? `${olaGroup.olaZCode} - ` : ""}{olaGroup.olaName}
                                      <span className="text-muted fw-normal">: {olaSummaryText}</span>
                                    </summary>
                                    <div className="mt-2">
                                      {olaGroup.created.length > 0 && (
                                        <div className="mb-3">
                                          <strong>Nieuwe toewijzingen</strong>
                                          <ul className="list-unstyled mb-0 mt-2">
                                            {olaGroup.created.map(renderAssignmentDiffItem)}
                                          </ul>
                                        </div>
                                      )}

                                      {olaGroup.updated.length > 0 && (
                                        <div className="mb-3">
                                          <strong>Gewijzigde toewijzingen</strong>
                                          <ul className="list-unstyled mb-0 mt-2">
                                            {olaGroup.updated.map(renderAssignmentDiffItem)}
                                          </ul>
                                        </div>
                                      )}

                                      {olaGroup.deleted.length > 0 && (
                                        <div>
                                          <strong>Verwijderde toewijzingen</strong>
                                          <ul className="list-unstyled mb-0 mt-2">
                                            {olaGroup.deleted.map(renderAssignmentDiffItem)}
                                          </ul>
                                        </div>
                                      )}
                                    </div>
                                  </details>
                                </li>
                              );
                            })}
                          </ul>
                        )
                      ) : (
                        <span>&nbsp;-</span>
                      )}
                          </div>
                        </details>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <span>&nbsp;-</span>
                )}
              </div>
            </div>
          </Col>
        </Row>
      )}

      <Row>
        <Col md={2}>
          <h3>Filter</h3>
          <hr />
          <Button
            variant={filterNotFull ? "secondary" : "outline-dark"}
            className="w-100 mb-3"
            onClick={() => setFilterNotFull(!filterNotFull)}
          >
            Onvolledige vakken
          </Button>
          <h4>Opleiding</h4>
          <ul className="list-group">
            {sortProgrammesLikeOpleidingenPage(programmes, isShownInOpleidingenFilter).map(programme => (
              <li key={programme.ID} className="list-group-item text-break">
                <Form.Check
                  inline
                  label={programme.name}
                  id={programme.ID}
                  type="checkbox"
                  checked={selectedProgrammeIDs.includes(programme.ID)}
                  onChange={e => toggleSelectedProgrammeFiler(programme.ID, e.target.checked)}
                />
              </li>
            ))}
          </ul>
          <h4>Fasen</h4>
          <ul className="list-group">
            {phaseIDs.slice().sort((a, b) => {
              const nameA = (phases.find(p => p.ID === parseInt(a, 10)) || {}).name || '';
              const nameB = (phases.find(p => p.ID === parseInt(b, 10)) || {}).name || '';
              return nameA.localeCompare(nameB);
            }).map(pid => (
              <li key={pid} className="list-group-item text-break">
                <Form.Check
                  inline
                  label={(phases.filter(p => p.ID === parseInt(pid, 10))[0] || {}).name}
                  id={pid}
                  type="checkbox"
                  onChange={e => toggleSelectedPhaseID(parseInt(pid, 10), e.target.checked)}
                />
              </li>
            ))}
          </ul>
          <h4>Tags</h4>
          <ul className="list-group">
            {tags.map(tag => (
              <li key={tag} className="list-group-item text-break">
                <Form.Check inline label={tag} id={tag} type="checkbox" onChange={e => toggleSelectedTag(tag, e.target.checked)} />
              </li>
            ))}
          </ul>
        </Col>
        <Col md={10}>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Z-Code</th>
                <th>Naam</th>
                <th>Opleiding</th>
                <th className="assigncol">Invulling</th>
              </tr>
            </thead>
            <tbody>
              {olas.map((c, olaIndex) =>
                c.internship ? (
                  <StageOLA
                    c={c}
                    className={`${c.show ? "" : "d-none"} ${highlightedOlaID === `${c.ID}` ? "table-active" : ""}`.trim()}
                    rowRef={el => {
                      if (el) {
                        olaRowRefs.current[`${c.ID}`] = el;
                      }
                    }}
                    olaIndex={olaIndex}
                    openVTESimulationModal={openVTESimulationModal}
                    openEdit={openEdit}
                    popover={popover}
                  />
                ) : (
                  <tr
                    key={c.ID}
                    ref={el => {
                      if (el) {
                        olaRowRefs.current[`${c.ID}`] = el;
                      }
                    }}
                    className={`${c.show ? "" : "d-none"} ${highlightedOlaID === `${c.ID}` ? "table-active" : ""}`.trim()}
                  >
                    <td>{c.opo.zCode} {c.zCode}</td>
                    <td>
                      <Button type="button" variant="link" className="force-left" onClick={() => openVTESimulationModal(c)}>
                        {c.name}
                      </Button>
                      <br />
                      <i className="fas fa-arrow-right" />
                      &nbsp;{(c.assignments.reduce((n, { vte }) => n + Math.round(vte * 2) / 2, 0) / 100).toFixed(3)}&nbsp;VTE
                      {c.teachersPerClass > 1 && (
                        <p>
                          <span>
                            <i className="far fa-user-friends" /> {c.teachersPerClass} per klas
                          </span>
                        </p>
                      )}
                    </td>
                    <td>{c.opo.programme.name}</td>
                    <td>
                      <Row className="mx-2">
                        {c.planPerPhase
                          ?

                          c.phases.slice().sort((a, b) => a.phase.name.localeCompare(b.phase.name)).map(olaPhase =>

                            Array.from(Array((olaPhase.numberOfClassesOverride ? olaPhase.numberOfClassesOverride : olaPhase.phase.numberOfClasses) * (olaPhase.teachersPerClassOverride != c.teachersPerClass && olaPhase.teachersPerClassOverride != null ? olaPhase.teachersPerClassOverride : c.teachersPerClass)))
                              .map((_, i) => i)
                              .map(i =>
                              (
                                <Col xs={2} className="my-2 px-1" key={c.id}>
                                  {c.assignments.filter(a => a.phaseID == olaPhase.phaseID).length < i + 1 ? (
                                    <OverlayTrigger trigger="click" rootClose placement="bottom" overlay={popover(c, olaPhase.phaseID, olaPhase.phase.color)}>
                                      <Button variant="outline-dark" className="plusButton" style={{ backgroundColor: olaPhase.phase.color }}>
                                        {olaPhase.phase.name} <i className="fas fa-plus" />
                                      </Button>
                                    </OverlayTrigger>
                                  ) : (
                                    <Button variant="outline-dark" className="collegaButton" style={{ backgroundColor: olaPhase.phase.color }} onClick={() => openEdit(olaIndex, c.assignments.filter(a => a.phaseID == olaPhase.phaseID)[i])}>
                                      <div className="collega-name text-truncate">
                                        {c.assignments.filter(a => a.phaseID == olaPhase.phaseID)[i].opoResponsible && (
                                          <span>
                                            <i className="far fa-award" />{" "}
                                          </span>
                                        )}{" "}
                                        {localStorage.getItem("SAT-typeName") === "volledig"
                                          ? c.assignments.filter(a => a.phaseID == olaPhase.phaseID)[i].collega.firstName
                                          : c.assignments.filter(a => a.phaseID == olaPhase.phaseID)[i].collega.initials}
                                      </div>
                                      {localStorage.getItem("SAT-typeName") === "volledig" && (
                                        <div className="collega-name text-truncate">{c.assignments.filter(a => a.phaseID == olaPhase.phaseID)[i].collega.lastName}</div>
                                      )}

                                      <div className="fw-bold assignmentVTE">
                                        {c.assignments.filter(a => a.phaseID == olaPhase.phaseID)[i].percentageOverride !== 0 && (
                                          <span className="text-warning">
                                            <i className="fas fa-bolt" />&nbsp;
                                          </span>
                                        )}
                                        {c.assignments.filter(a => a.phaseID == olaPhase.phaseID)[i].numberOfAssignments > 1 && (
                                          <span>{Math.round(c.assignments.filter(a => a.phaseID == olaPhase.phaseID)[i].vte * 2) / 2}%/</span>
                                        )}
                                        {Math.round(c.assignments.filter(a => c.assignments.filter(a => a.phaseID == olaPhase.phaseID)[i].collegaID == a.collegaID
                                        ).reduce((n, { vte }) => n + vte, 0) * 2) / 2}%
                                        {(c.assignments.filter(a => a.phaseID == olaPhase.phaseID)[i].comment || c.assignments.filter(a => a.phaseID == olaPhase.phaseID)[i].commentTeacher) && (
                                          <span className="text-info">
                                            &nbsp;<i className="far fa-comment-dots" />
                                          </span>
                                        )}
                                      </div>
                                    </Button>
                                  )}
                                </Col>)
                              )


                          )

                          :

                          Array.from(Array(c.classes))
                            .map((_, i) => i)
                            .map(i => (
                              <Col xs={2} className="my-2 px-1" key={i}>
                                {c.assignments.length < i + 1 ? (
                                  <OverlayTrigger trigger="click" rootClose placement="bottom" overlay={popover(c)}>
                                    <Button className="plusButton">
                                      <i className="fas fa-plus" />
                                    </Button>
                                  </OverlayTrigger>
                                ) : (
                                  <Button variant="outline-dark" className="collegaButton" onClick={() => openEdit(olaIndex, c.assignments[i])}>
                                    <div className="collega-name text-truncate">
                                      {c.assignments[i].opoResponsible && (
                                        <span>
                                          <i className="far fa-award" />{" "}
                                        </span>
                                      )}{" "}
                                      {localStorage.getItem("SAT-typeName") === "volledig"
                                        ? c.assignments[i].collega.firstName
                                        : c.assignments[i].collega.initials}
                                    </div>

                                    {localStorage.getItem("SAT-typeName") === "volledig" && (
                                      <div className="collega-name text-truncate">{c.assignments[i].collega.lastName}</div>
                                    )}

                                    <div className="fw-bold assignmentVTE">
                                      {c.assignments[i].percentageOverride !== 0 && (
                                        <span className="text-warning">
                                          <i className="fas fa-bolt" />&nbsp;
                                        </span>
                                      )}
                                      {c.assignments[i].numberOfAssignments > 1 && (
                                        <span>{Math.round(c.assignments[i].vte * 2) / 2}%/</span>
                                      )}
                                      {Math.round(c.assignments.filter(x => x.collegaID == c.assignments[i].collegaID).reduce((n, { vte }) => n + parseFloat(vte), 0) * 2) / 2}%
                                      {(c.assignments[i].comment || c.assignments[i].commentTeacher) && (
                                        <span className="text-info">
                                          &nbsp;<i className="far fa-comment-dots" />
                                        </span>
                                      )}
                                    </div>
                                  </Button>
                                )}
                              </Col>
                            ))

                        }
                      </Row>
                    </td>
                  </tr>
                ),
              )}
            </tbody>
          </Table>
        </Col>
      </Row>
    </Container>
  );
}

export default OLAAssignment;
